import { useState } from 'react';

type DocumentsTabProps = {
  data: string[];
  setData: (docs: string[]) => void;
  newDoc: string;
  setNewDoc: (val: string) => void;
};

export default function DocumentsTab({
  data,
  setData,
  newDoc,
  setNewDoc,
}: DocumentsTabProps) {
  const addDoc = () => {
    const trimmed = newDoc.trim();
    if (trimmed && !data.includes(trimmed)) {
      setData([...data, trimmed]);
    }
    setNewDoc('');
  };

  const removeDoc = (i: number) => {
    setData(data.filter((_, idx) => idx !== i));
  };

  return (
    <div>
      <h2 className="text-[#6E3EF5] text-lg mb-5">Documents Required</h2>

      <div className="flex flex-col gap-2.5 mb-5">
        {data.map((doc, i) => (
          <div
            key={i}
            className="px-4 py-3 bg-[#F9F6FF] border border-[#F0F0F0] rounded-lg flex justify-between items-center"
          >
            <span className="text-sm text-gray-700">{doc}</span>
            <button
              onClick={() => removeDoc(i)}
              className="text-gray-300 hover:text-red-500 text-lg leading-none px-1 transition-colors cursor-pointer bg-transparent border-none"
            >
              ×
            </button>
          </div>
        ))}
      </div>

      <div className="flex gap-2">
        <input
          value={newDoc}
          onChange={(e) => setNewDoc(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && addDoc()}
          placeholder="Add a new document..."
          className="flex-1 px-4 py-2.5 border border-[#F0F0F0] rounded-lg bg-black/[0.004] text-sm outline-none focus:border-violet-600 transition-colors"
        />
        <button
          onClick={addDoc}
          className="px-4 py-2.5 bg-violet-100 text-violet-700 font-semibold text-sm rounded-xl hover:bg-violet-200 transition-colors cursor-pointer border-none"
        >
          + Add
        </button>
      </div>
    </div>
  );
}
